module.exports = __webpack_public_path__ + "static/media/searchWhite.a78ca6b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/searchWhite.svg
// module id = 250
// module chunks = 27